// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Logo-module--cls1--2H29h","cls2":"styles-Logo-module--cls2--s08bL styles-Logo-module--cls1--2H29h"};